import React, { lazy, Suspense, useEffect, useState } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import LoadingScreen from 'shared/components/LoadingScreen/LoadingScreen';
import './App.scss';
import HomeContainer from './app/HomeContainer/HomeContainer';
import { NavigationRoutesInterface } from './domain/navigation-routes';
import Footer from './shared/components/Footer/Footer';
import Navigation from './shared/components/Navigation/Navigation';
import Toolbar from './shared/components/Toolbar/Toolbar';
import NavigationIcon from './shared/icons/NavigationIcon';
import {useExploraDispatch, useExploraState} from "./app/store/explora-context";
import {ExploraRequestAction} from "./app/store/actions";
import RouteChangeTracker from 'shared/components/GoogleAnalytics/RouteChangeTracker';
import SitemapContainer from './app/SiteMap/SitemapContainer';

const ProductionsContainer = lazy(() => import('app/ProductionsContainer/ProductionsContainer'));
const UsContainer = lazy(() => import('app/UsContainer/UsContainer'));
const BlogContainer = lazy(() => import('app/BlogContainer/BlogContainer'));
const BlogDetailContainer = lazy(() => import('app/BlogDetailContainer/BlogDetailContainer'));
const ContactContainer = lazy(() => import('app/ContactContainer/ContactContainer'));


export const iniRoutes: NavigationRoutesInterface[] = [
  {
    label: 'Inicio',
    path: '/home',
    Icon: NavigationIcon,
    protected: false
  },
  {
    label: 'Producciones',
    path: '/productions',
    Icon: NavigationIcon,
    protected: false
  },
  {
    label: 'Nosotros',
    path: '/us',
    Icon: NavigationIcon,
    protected: false
  },
  {
    label: 'Blog',
    path: '/blog',
    Icon: NavigationIcon,
    protected: false
  },
  {
    label: 'Contáctanos',
    path: '/contact',
    Icon: NavigationIcon,
    protected: false
  }
];

function App() {
  const [isOpen, setIsOpen] = useState(false);
  const { pathname, hash } = useLocation();
  const [routes, setRoutes] = useState(iniRoutes.filter(r => r.protected !== true));
  const dispatch = useExploraDispatch();
  const { auth } = useExploraState();

  useEffect(() => {
    if (hash) {
      const anchor = document.querySelector(hash);
      if (anchor) {
        anchor.scrollIntoView({ block: 'center' });
      }
    } else {
      window.scrollTo(0, 0);
    }

  }, [pathname, hash, dispatch]);

  return (
    <>
      <Toolbar isOpen={isOpen} setIsOpen={setIsOpen} headerImage="explora-logo" routes={routes}>
        <Navigation routes={routes} />
      </Toolbar>
      <main className="app-main">
        <Switch>
          <Route path="/home">
            <HomeContainer />
          </Route>
          <Route path="/productions">
            <Suspense fallback={<LoadingScreen />}>
              <ProductionsContainer />
            </Suspense>
          </Route>
          <Route path="/us">
            <Suspense fallback={<LoadingScreen />}>
              <UsContainer />
            </Suspense>
          </Route>
          <Route path="/blog/:id">
            <Suspense fallback={<LoadingScreen />}>
              <BlogDetailContainer />
            </Suspense>
          </Route>
          <Route exact path="/blog">
            <Suspense fallback={<LoadingScreen />}>
              <BlogContainer />
            </Suspense>
          </Route>
          <Route path="/contact">
            <Suspense fallback={<LoadingScreen />}>
              <ContactContainer />
            </Suspense>
          </Route>
          <Route path="/sitemap">
            <Suspense fallback={<LoadingScreen />}>
              <SitemapContainer />
            </Suspense>
          </Route>
          <Redirect from="*" to="/home" />
          <RouteChangeTracker />
        </Switch>
      </main>
      <Footer routes={routes} />
      <RouteChangeTracker />
    </>
  );
}

export default App;